import type { DocPageContent } from '../docs-content'

// order 11.5 coloca esto justo después de Texto, Subtítulos y Leyendas en Herramientas Creativas.
const page = {
  order: 11.5,
  slug: 'shapes-masks',
  title: 'Formas y Máscaras',
  description:
    'Añade elementos de forma, dibuja trazados personalizados con la herramienta pluma y usa cualquier forma como máscara de clip.',
  category: 'Herramientas Creativas',
  related: ['properties', 'effects-color', 'keyframes'],
  sections: [
    {
      title: 'Añadir una forma',
      blocks: [
        {
          kind: 'list',
          items: [
            'Abre la pestaña **Formas** y haz clic en una forma para añadirla en el cabezal de reproducción, o arrástrala a una pista específica.',
            'Formas integradas: **Rectángulo**, **Círculo**, **Elipse**, **Triángulo**, **Estrella**, **Polígono** y **Corazón**.',
            'Una nueva forma aparece con el tamaño del lienzo y seleccionada, lista para posicionar y estilizar.',
          ],
        },
      ],
    },
    {
      title: 'Estilizar una forma',
      blocks: [
        {
          kind: 'table',
          headers: ['Control', 'Notas'],
          rows: [
            ['Tipo', 'Cambia entre los siete tipos de forma.'],
            ['Relleno', 'El color de la forma.'],
            [
              'Anch. Trazo / Trazo',
              'Ancho del contorno (0–50 píxeles) y su color (se muestra cuando el ancho es superior a 0).',
            ],
            ['Radio', 'Redondeo de esquinas (0–100 píxeles) para rectángulo, triángulo, estrella y polígono.'],
            ['Puntos / R. Interior', 'Número de puntos y radio interior, para estrella y polígono.'],
            ['Dirección', 'Hacia dónde apunta un triángulo.'],
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: 'La posición, el tamaño, la rotación y la opacidad se encuentran en los controles de Transformación, y la mayoría de los valores se pueden animar con fotogramas clave — consulta [Animación con Fotogramas Clave](keyframes).',
        },
      ],
    },
    {
      title: 'Dibujar un trazado personalizado con la herramienta pluma',
      blocks: [
        {
          kind: 'steps',
          items: [
            'En la pestaña Formas, elige la herramienta **Pluma** para dibujar una forma de trazado personalizado.',
            'Haz clic en la vista previa para colocar puntos; haz clic y arrastra un punto para extender asas curvas (bezier).',
            'Retroceso elimina el último punto, y Escape cancela.',
            'Con al menos tres puntos, elige **Finalizar Forma** para confirmarla (o **Cancelar**).',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Para remodelar un trazado más tarde, selecciónalo y usa **Editar Trazado**: arrastra puntos y asas, haz doble clic en un borde para añadir un punto y convierte un punto entre **Esquina** y **Bezier**. Elige **Listo** cuando termines.',
        },
      ],
    },
    {
      title: 'Usar una forma como máscara',
      blocks: [
        {
          kind: 'steps',
          items: [
            'Coloca la forma en una pista **superior** al clip que quieres enmascarar.',
            'En la sección Forma, activa **Usar como Máscara**.',
            'Elige un **Tipo de Máscara**: **Clip** para bordes duros, o **Alfa** para bordes suaves.',
            'Para una máscara Alfa, ajusta **Suavizado** para difuminar el borde; usa **Invertir** para ocultar el área de la forma en lugar de revelarla.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Una máscara afecta a todo lo que está en las pistas inferiores, según la geometría de la forma. El suavizado solo se aplica a las máscaras Alfa — las máscaras Clip mantienen bordes duros.',
        },
        {
          kind: 'note',
          tone: 'warning',
          text: 'Mientras editas una máscara o dibujas con la pluma, el resto del editor está bloqueado — finaliza o sale de la edición de máscara para continuar.',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page